import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

const resources = {
  en: {
    translation: {
      swapSessionRules: {
        BOOKABLE_SERVICES_OF_SHIFTS_ARE_MATCHING: {
          pass: "Shift's bookable services match",
          fail: "Shift's bookable services do not match"
        },
        TARGET_PERFORMER_TIMESLOT_IS_BOOKABLE: {
          pass: "<0>{{targetPerformerName}}</0>'s slot is bookable",
          fail: "<0>{{targetPerformerName}}</0>'s slot is unbookable"
        },
        TARGET_PERFORMER_IS_ACCREDITED: {
          pass: "<0>{{targetPerformerName}}</0> is accredited for <0>{{sourcePerformerName}}</0>'s content",
          fail: "<0>{{targetPerformerName}}</0> is <0>not</0> accredited for <0>{{sourcePerformerName}}</0>'s content"
        },
        SOURCE_PERFORMER_IS_ACCREDITED: {
          pass: "<0>{{sourcePerformerName}}</0> is accredited for <0>{{targetPerformerName}}</0>'s content",
          fail: "<0>{{sourcePerformerName}}</0> is <0>not</0> accredited for <0>{{targetPerformerName}}</0>'s content"
        }
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false // react already safes from xss
  },
});

export default i18n;